import { Component, OnInit } from '@angular/core';
import { TipService } from '../../service/tip/tip.service';
import { Tip } from '../../class/tip';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';


@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss']
})
export class TipsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public tips: Tip[];
    public selectTip: Tip;
    public tipID: Number = 0;
    public modNew = false;
    public modView = false;
    public openTip = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public tipService: TipService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService) { }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;

        //this.getTips();
    }

    public loadTipsLazy(event: LazyLoadEvent) {
        event.sortField = 'id';
        event.sortOrder = -1;
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort = event.sortField;
        }
        this.getTips(event.globalFilter);
    }

    public getTips(query?: string) {
        this.tipService.getTip(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.tips = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newTip() {
        this.modNew = !this.modNew;
        this.selectTip = null;
    }

    public savedTip(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectTip = null;
        this.modNew = false;
        this.getTips();
    }

    public cancelTip (res) {
        this.selectTip = null;
        this.modNew = false;
        this.modView = false;
        this.getTips();
    }

    public edit(tip: Tip) {
        this.modNew = true;
        this.selectTip = tip;
        this.getTips();
    }

    public view(tip: Tip) {
        this.openTip = true;
        this.selectTip = tip;
        this.tipID = tip.id;
        this.modView = true;
    }

    public deleteDialog(tip: Tip) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(tip);
            }
        });
    }

    public delete(tip: Tip) {
        this.tipService.deleteTip(tip.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'Borrado satisfactoriamente' } );
                this.getTips();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeTip(tip: Tip) {
        this.putTip(tip);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putTip(values: Tip) {
        const param = {
        };
        if (values) {
            const promise = this.tipService.updateTip(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/tips/tips.component.ts